import { render, staticRenderFns } from "./SemiFinishedProductsList.vue?vue&type=template&id=34da583e&scoped=true&"
import script from "./SemiFinishedProductsList.vue?vue&type=script&lang=js&"
export * from "./SemiFinishedProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34da583e",
  null
  
)

export default component.exports